import { Injectable } from '@angular/core';
import { BaseAPIService } from '@lbmx/phoenix-lib-core';
import { AppSetting } from '@lbmx/types';
import { Observable } from 'rxjs';
import {
  GroupToken,
  IAddGroupingMemberRequest,
  IConfigCountry,
  IConfigProvince,
  IGroupLinkValidationResponse,
  INewSupplierProfileForm,
} from 'src/app/dtos/group/group.dto';
import { ConfigProvider } from 'src/app/provider/config-provider';

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  public appSettings: AppSetting = this.configPrv.AppSetting;
  constructor(
    private baseApiService: BaseAPIService,
    private configPrv: ConfigProvider
  ) {}

  public validateGroupLink(
    request: GroupToken
  ): Observable<IGroupLinkValidationResponse> {
    // this.baseApiService.set(
    //   this.appSettings.uriGroup.validateGroup
    // );
    return this.baseApiService.post(request).pipe();
  }

  public submitNewMember(request: IAddGroupingMemberRequest): Observable<any> {
    // this.baseApiService.set(
    //   //this.appSettings.uriGroup.submitNewMember
    // );
    return this.baseApiService.post(request).pipe();
  }

  public submitNewSupplier(request: INewSupplierProfileForm): Observable<any> {
    // this.baseApiService.set(
    //   this.appSettings.uriGroup.submitNewSupplier
    // );
    return this.baseApiService.post(request).pipe();
  }

  public getCountries(): Observable<IConfigCountry[]> {
    this.baseApiService.set(this.appSettings.uriConfig.getCountries);
    return this.baseApiService.get<IConfigCountry[]>();
  }

  public getProvinces(): Observable<IConfigProvince[]> {
    this.baseApiService.set(this.appSettings.uriConfig.getProvinces);
    return this.baseApiService.get<IConfigProvince[]>();
  }
}
